import { useEffect } from "react";
import { connect } from "react-redux";
import { type Dispatch, type UnknownAction } from "redux";
import { useHistory, useLocation } from "react-router-dom";

import { listTraders as listTradersAction } from "../../actions";
import { adaptTrader } from "../../utils/adapters";
import { DispatchProps, RepresentativeProfileGateProps, ReduxState, StateProps } from "./types";

const PROFILE_PATH = "/representative/profile";

type AppDispatch = Dispatch<UnknownAction>;

const dispatchAction = (dispatch: AppDispatch, action: unknown) =>
  dispatch(action as UnknownAction);

// Runs after the Terms of Use gate on every representative route: once the buyer
// has accepted the latest terms, prompts them to complete a profile still missing
// its physical address, instead of only when they open Offers.
export const RepresentativeProfileGate = ({
  currentUser,
  trader,
  fetchTraders,
}: RepresentativeProfileGateProps) => {
  const history = useHistory();
  const { pathname, state } = useLocation<{ fromProfileUpdate?: boolean } | undefined>();

  useEffect(() => {
    fetchTraders();
  }, [fetchTraders]);

  const termsAccepted =
    currentUser.terms_and_conditions_accepted_version ===
    currentUser.terms_and_conditions_latest_version;
  const profileIncomplete = Boolean(trader?.name) && !trader?.physical_address;

  useEffect(() => {
    if (
      termsAccepted &&
      profileIncomplete &&
      pathname !== PROFILE_PATH &&
      !state?.fromProfileUpdate
    ) {
      history.push(PROFILE_PATH, { updateDetails: true });
    }
  }, [termsAccepted, profileIncomplete, pathname, state, history]);

  return null;
};

const mapStateToProps = (reduxState: ReduxState): StateProps => ({
  currentUser: reduxState.userDetail.data,
  trader: adaptTrader(reduxState.listTraders.data.results ?? []),
});

const mapDispatchToProps = (dispatch: AppDispatch): DispatchProps => ({
  fetchTraders: () => dispatchAction(dispatch, listTradersAction()),
});

export const ConnectedRepresentativeProfileGate = connect(
  mapStateToProps,
  mapDispatchToProps
)(RepresentativeProfileGate);
